import * as _ from "underscore";
import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
  name: "activeClientsOnly",
  standalone: true,
})
export class ActiveClientsOnlyPipe implements PipeTransform {
  transform(array: Array<any>, args?: any): any {
    if (array != null) {
      const filtered = array.filter((w) => w.archived === false);
      console.log(`total: ${array.length}, filtered: ${filtered.length}`);
      return filtered;
    }
  }
}
